"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TagCategoryActions_1 = __importDefault(require("../actions/TagCategoryActions"));
const ajax_1 = __importDefault(require("../endpoints/ajax"));
const TagCategorySource = {
    fetchData() {
        return {
            remote(state) {
                return ajax_1.default.tagCategories();
            },
            local() {
                return null;
            },
            success: TagCategoryActions_1.default.receivedItems,
            loading: TagCategoryActions_1.default.loadingItems,
            error: TagCategoryActions_1.default.fetchingItemsFailed,
        };
    },
};
exports.default = TagCategorySource;
